import { DocumentData } from "@angular/fire/firestore";
import { ProductInventorySettings } from "../models";

export class ProductInventorySettingsBuilder {
  public price: number;
  public max: number;
  public limit: number;
  constructor() {}

  edit(inventory: ProductInventorySettings) {
    this.price = inventory.price;
    this.max = inventory.max;
    this.limit = inventory.limit;
  }

  load(data: DocumentData) {
    this.price = data.price / 100;
    this.max = data.max;
    this.limit = data.limit;
  }
  setPrice(price: number) {
    this.price = price;
    return this;
  }
  setMaxAvailibility(max: number) {
    this.max = max;
    return this;
  }
  setLimit(limit: number) {
    this.limit = limit;
    return this;
  }
}
